<script lang="ts">
    import Card from "../UiCommenCard.svelte";
    import {Col, Row }from "sveltestrap";
    import {NestingColumn, VerticalalignmentMessage} from "../../../utils/Constant/Constant"
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={NestingColumn} CardBodyprops="grid-showcase">
      <div slot="contentbody">
        <p>{VerticalalignmentMessage}</p>
        <Row>
          <Col sm="9">
            <span>Level 1: .col-sm-9</span>
            <Row>
                <Col xs="8" sm="6">
                    <span>Level 2: .col-8 .col-sm-6</span>
                </Col>
                <Col xs="4" sm="6">
                    <span>Level 2: .col-4 .col-sm-6</span>
                </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Card>
</Col>